import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Logo } from '../../components/LogoSection/Components/Logo.js';
import WithLink from '../../components/LogoSection/Components/WithLink.js';
import { qaId } from '../../utils/index.js';
import { useDirectusImageUrl } from '../../utils/directus.js';
import { HEADER_QA_ID } from '../../utils/qaId.js';
const LogoSection = ({
  logoConfig,
  path,
  pageType,
  width = 147,
  height = 55,
  ...restProps
}) => {
  const {
    type,
    url,
    isClickable,
    alt
  } = logoConfig;
  // @FIXME
  // Toolkit shouldn't be aware of directus even existing.
  // Components should simply get urls and use them.
  // The consumer can then decide how/where to get the urls.
  const directusImageSource = useDirectusImageUrl(url);
  if (!url) return;
  const imageSource = type === 'directus' ? directusImageSource : url;
  return _jsx(WithLink, {
    logoClickable: isClickable && pageType !== 'book',
    path: path,
    ...restProps,
    children: _jsx(Logo, {
      src: imageSource,
      alt: alt,
      width: width,
      height: height,
      "data-cy": qaId(HEADER_QA_ID, 'logo', 'picture'),
      "data-testid": qaId(HEADER_QA_ID, 'logo', 'picture')
    })
  });
};
export default LogoSection;